module.exports = __webpack_public_path__ + "img/logoGazit.246228ef.png";